import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useLayoutEffect } from "react";

const AutofocusPlugin = () => {
	const [editor] = useLexicalComposerContext();

	useLayoutEffect(() => {
		editor.focus();
	}, [editor]);

	return null;
};

export default AutofocusPlugin;
